import {
  SUBTRACT_SELECT_ALL,
  ADD_SELECT_ALL,
  ADD_ROLES_COUNT,
  SUBTRACT_ROLES_COUNT,
} from '../../../../../../../../../constants/slate/documentOps';

const setDocumentData = ({
  editor,
  currentDocument,
  currentDocumentDataJSON,
  selectAll,
  documentRolesCount,
}) => {
  editor.setNodeByKey(currentDocument.key, {
    data: {
      ...currentDocumentDataJSON,
      selectAll,
      rolesCount: documentRolesCount,
    },
  });
};

export default (params) => {
  const {
    selectAllCount,
    documentRolesCount,
    currentDocument,
    editor,
    documentUpdateType,
  } = params;
  if (selectAllCount >= 1) {
    const currentDocumentDataJSON = currentDocument.data.toJSON();

    /**
     * Update the document selectAll count on updating check marks of
     * inner cards - organization details or roles
     */
    let documentSelect = currentDocumentDataJSON.selectAll;
    if (documentUpdateType === ADD_SELECT_ALL) {
      documentSelect = currentDocumentDataJSON.selectAll + 1;
      setDocumentData({
        editor,
        currentDocument,
        currentDocumentDataJSON,
        selectAll: documentSelect,
        documentRolesCount,
      });
    } else if (
      documentUpdateType === ADD_ROLES_COUNT ||
      documentUpdateType === SUBTRACT_ROLES_COUNT
    ) {
      documentSelect = currentDocumentDataJSON.selectAll;
      setDocumentData({
        editor,
        currentDocument,
        currentDocumentDataJSON,
        selectAll: documentSelect,
        documentRolesCount,
      });
    } else if (documentUpdateType === SUBTRACT_SELECT_ALL) {
      documentSelect = currentDocumentDataJSON.selectAll - 1;
      setDocumentData({
        editor,
        currentDocument,
        currentDocumentDataJSON,
        selectAll: documentSelect,
        documentRolesCount,
      });
    }
  } else {
    const currentDocumentDataJSON = currentDocument.data.toJSON();

    if (documentUpdateType === SUBTRACT_SELECT_ALL) {
      setDocumentData({
        editor,
        currentDocument,
        currentDocumentDataJSON,
        selectAll: currentDocumentDataJSON.selectAll - 1,
        documentRolesCount,
      });
    } else if (documentUpdateType === ADD_SELECT_ALL) {
      setDocumentData({
        editor,
        currentDocument,
        currentDocumentDataJSON,
        selectAll: currentDocumentDataJSON.selectAll + 1,
        documentRolesCount,
      });
    } else if (
      documentUpdateType === ADD_ROLES_COUNT ||
      documentUpdateType === SUBTRACT_ROLES_COUNT
    ) {
      setDocumentData({
        editor,
        currentDocument,
        currentDocumentDataJSON,
        selectAll: currentDocumentDataJSON.selectAll,
        documentRolesCount,
      });
    }
  }
};
